import * as Theme from "../../../../app/Theme";

import PIContRefTable from "../../Tables/Reference/PIContRefTable";

import { RS } from "../../../../data/strings/global";
import * as SC from "../../../../data/strings/PIStringConst";
import TButton from "../../../common/TButton";
import * as gbu from "../../../GB/GBUtil";
import * as pic from "../../NonComponents/PIConst";

const PIContinuationRefForm = (props) => {
  return (
    <div style={{ marginLeft: Theme.leftIndent }}>
      <p style={Theme.labelStyle}>{RS(SC.GB_stEmpCurvesPriorStudies)}</p>
      <PIContRefTable modVarObjList={props.modVarObjList} />
      <div style={{ marginTop: Theme.contentMarginTop, maxWidth: 1000, ...Theme.textFontStyle }}>
        {RS(SC.GB_stContinuationRefNote)} <a href={"mailto:prepithelp@avenirhealth.org"}>prepithelp@avenirhealth.org</a>
        .
      </div>
      <TButton
        style={{
          marginTop: Theme.contentMarginTop,
          marginLeft: 0,
        }}
        caption={RS(SC.GB_stDownloadAvailableContinuationData)}
        onClick={() => gbu.resourceClick(pic.availableContinuationDataXLSX)}
      />
    </div>
  );
};

export default PIContinuationRefForm;
